import { render, staticRenderFns } from "./QuickProtocolCreateForm.vue?vue&type=template&id=bfc4150e&scoped=true"
import script from "./QuickProtocolCreateForm.vue?vue&type=script&lang=js"
export * from "./QuickProtocolCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc4150e",
  null
  
)

export default component.exports